import { Grid, Paper } from "@material-ui/core";
import React, { useState } from "react";
import { SaveButton, SimpleForm, Tab, TabbedShowLayout, Toolbar, useDataProvider } from "react-admin";
import { useHistory, useLocation } from "react-router-dom";
import { EightWingsStatus, EightWingsTabEnum } from "../../../../Enums/EightWingsTabEnum";
import { ModelState } from "../../Models/ModelStateEnum";
import EightWingsInfo from "./EightWingsInfo";
import EightWingsServiceable from "./EightWingsServiceable/EightWingsServiceable";
// import EightWingsRequestOrderFiles from './EightWingsRequestOrderFiles';
import RequestHistoryTimeLine from "../RequestHistoryTimeLine";
// import EightWingsRequestUnserviceable from '../EightWingsRequestUnserviceable/EightWingsRequestUnserviceable';
import { connect } from "react-redux";
import { RequestOrderTabEnum } from "../../../../Enums/RequestOrderTabEnum";
import { PBH_REQUEST_SET_FILES, PBH_REQUEST_SET_FILES_LOADING } from "../../../../Redux/actions";
import PbhRequestOrderFiles from "../PbhRequestOrderEdit/PbhRequestOrderFiles";
import EightWingsUnserviceable from "./EightWingsUnserviceable/EightWingsUnserviceable";

const BlankToolbar = props => (
  <Toolbar {...props} placeholder="" {...props} className="blank-toolbar">
    <SaveButton label="" />
  </Toolbar>
);

const EightWingsEdit = props => {
  const history = useHistory();
  const provider = useDataProvider();
  const location = useLocation();
  const eightWingsId: string = location?.pathname?.split("/")[2];
  const [mainData, setMainData] = useState(null as any);
  const [selectedRequestOrderFileType, setSelectedRequestOrderFileType] = useState(null as number | null);
  const [activeTab, setActiveTab] = useState(RequestOrderTabEnum.InfoTab as string | number);

  React.useEffect(() => {
    let currentTab: string | number = location?.pathname?.split?.("/")?.[3];
    currentTab = currentTab ? currentTab : RequestOrderTabEnum.InfoTab;
    if (currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
  }, [location?.pathname]);
  React.useEffect(() => {
    getMainData();
  }, [eightWingsId]);

  const filesVisible = (): boolean => {
    return (
      activeTab == EightWingsTabEnum.ServiceableTab ||
      activeTab == EightWingsTabEnum.UnserviceableTab ||
      activeTab == EightWingsTabEnum.InfoTab
    );
  };

  const unserviceableTabVisible = (): boolean => {
    return mainData?.status != EightWingsStatus.Open;
  };

  const serviceableTabVisible = (): boolean => {
    return mainData?.status != EightWingsStatus.Open;
  };

  const getMainData = async () => {
    props?.setFilesLoading(true);
    provider
      .getOne("eightwings", { id: eightWingsId })
      .then(response => {
        if ((response?.data?.id as any) > 0) {
          var requestData = response.data;
          setMainData(requestData);
          props?.setFiles(requestData?.requestDetail?.pbhRequestOrderFiles);
        }
      })
      .catch(error => {})
      .finally(() => props?.setFilesLoading(false));
  };

  const parentCallBack = async e => {
    getMainData();
  };

  const changeRequestOrderFileType = value => {
    setSelectedRequestOrderFileType(value.target.value);
  };
  return (
    <SimpleForm submitOnEnter={false} toolbar={<BlankToolbar />}>
      <Grid container spacing={2} style={{ width: "100%" }}>
        <Grid item xs={12} sm={9}>
          <form>
            <Paper>
              <>
                <TabbedShowLayout>
                  {mainData !== null && (
                    <Tab id="info" key="info" label="INFO">
                      <EightWingsInfo
                        id="pbhrequestinfotab"
                        eightWingsId={eightWingsId}
                        selectedData={mainData?.requestDetail}
                        isNotInDafzaOrCoreReturn={mainData?.isNotInDafzaOrCoreReturn}
                        status={mainData?.status}
                      />
                    </Tab>
                  )}
                  {serviceableTabVisible() && (
                    <Tab
                      id="serviceable"
                      key="serviceable"
                      label="SERVICEABLE"
                      path={EightWingsTabEnum.ServiceableTab.toString()}
                    >
                      <EightWingsServiceable
                        eightWingsId={eightWingsId}
                        eightWingsStatus={mainData?.status}
                        requestId={mainData?.requestDetail?.id}
                        requestDetailData={mainData?.requestDetail}
                        requestServiceableData={mainData?.requestDetail?.pbhRequestServiceable ?? null}
                        parentCallBack={parentCallBack}
                      />
                    </Tab>
                  )}
                  {unserviceableTabVisible() && (
                    <Tab
                      id="unserviceable"
                      key="unserviceable"
                      label="CORE UNIT"
                      path={EightWingsTabEnum.UnserviceableTab.toString()}
                    >
                      <EightWingsUnserviceable
                        ModelState={ModelState.Create}
                        eightWingsId={eightWingsId}
                        requestId={mainData?.requestDetail?.id}
                        requestDetailData={mainData?.requestDetail}
                        requestUnserviceableData={mainData?.requestDetail?.pbhRequestUnserviceable ?? null}
                        parentCallBack={parentCallBack}
                      />
                    </Tab>
                  )}
                </TabbedShowLayout>
              </>
            </Paper>
            {filesVisible() && (
              <PbhRequestOrderFiles
                mainData={mainData?.requestDetail}
                activeTab={activeTab}
                changeRequestOrderFileType={changeRequestOrderFileType}
                selectedRequestOrderFileType={selectedRequestOrderFileType}
                getRequestDetail={getMainData}
                requestId={mainData?.requestDetail?.id ?? 0}
                {...props}
              />
            )}
          </form>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Paper>
            <Tab id="history" key="history" label="HISTORY">
              <RequestHistoryTimeLine
                secondRequest={mainData?.requestDetail ?? {}}
                secondSource="PbhRequestOrderHistorys"
                request={
                  mainData != null
                    ? {
                        ...mainData,
                        ...{ customerPo: mainData?.requestDetail?.customerPo, refNo: mainData?.requestDetail?.refNo },
                      }
                    : null
                }
                source="EightWingsRequestOrderHistorys"
              />
            </Tab>
          </Paper>
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  setFiles: data => dispatch({ type: PBH_REQUEST_SET_FILES, payload: data }),
  setFilesLoading: loading => dispatch({ type: PBH_REQUEST_SET_FILES_LOADING, payload: loading }),
});
export default connect(mapStateToProps, mapDispatchToProps)(EightWingsEdit);
